<template>
    <div class="page-top">
        <div class="hero is-bold has-background" :style="style">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-mobile">
                        <div class="column title_wrapper relative">
                            <h1 class="title">{{title}}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <slot name="breadcrumbs">
            <div class="breadcrumbs" v-if="breadcrumbs">
                <div class="container">
                    <span class="is-pulled-left">
                        <b-icon icon="link-variant" />
                    </span>

                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <template v-for="crumb in breadcrumbs">
                                <router-link tag="li" active-class="is-active"
                                             :to="crumb.route"
                                             exact>
                                    <router-link :to="crumb.route" exact>{{ crumb.title }}</router-link>
                                </router-link>
                            </template>
                        </ul>
                    </nav>
                </div>
            </div>
        </slot>

        <slot/>
    </div>

</template>

<style lang="scss" scoped>
    @import '../styles/_variables';

    .page-top {
        .hero {
            background-color: $white-ter;

            .title_wrapper {
                height: 100px;

                h1.title {
                    background-color: $white;
                    display: inline-block;
                    padding: 5px 10px;

                    position: absolute;
                    bottom: 15px;
                }
            }
        }

        .breadcrumbs {
            background-color: $primary;
            color: $white;
            padding: 10px;

            .icon {
                margin-right: 5px;
            }

            li::before {
                color: $white-ter;
            }

            a {
                color: $white;

                &:hover {
                    text-decoration: underline;
                    color: $white;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: [
            'breadcrumbs',
            'title',
            'background',
        ],

        computed: {
            style() {
                if (!this.background) {
                    return {};
                }

                return { background: this.background };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/global/components/PageTop.vue